<template lang="pug">
  #app(:class="theme")
    .logo-header
      logo
    transition(name="fade" mode="out-in")
      router-view(:key='$route.fullPath')
</template>

<script>
export default {
  computed: {
    theme(){
      const theme = this.$store.state.theme
      return {
        ['theme-' + theme]: true,
      }
    },
  },
}
</script>

<style lang="sass">
@import ./sass/main.sass

#app
  width: 100%
  height: 100%
  background-color: var(--bg1)
  color: var(--fg1)
  transition: all 0.5s
  display: flex
  flex-direction: column
  overflow: auto

  .logo-header
    flex-grow: 0
    flex-shrink: 0
    padding: 2em $margin-percent
    max-width: 60em
    margin: auto
</style>
